import { LoaderFunctionArgs, redirect, matchPath } from "react-router-dom";
import { getBasePathWithTrailingSlash } from "../../../../common/env.ts";

export default function exploreRedirector({
  request,
  params,
}: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const suffix = params["*"];
  const isAdminUrl = !!matchPath(
    getBasePathWithTrailingSlash() + "admin/*",
    url.pathname
  );
  const isGroupsUrl = !!matchPath(
    getBasePathWithTrailingSlash() + "classes/*",
    url.pathname
  );

  if (isAdminUrl) {
    return redirect(`/admin#/${suffix}`);
  }

  if (isGroupsUrl) {
    return redirect(`/classes#/${suffix}`);
  }

  return null;
}
